export const UPDATEUSERINFO = 'updateUserInfo'
export const SETWEBSET = 'setWebset'
export const UPDATEMENUDATA = 'updateMenudata'
export const SETTENANTID = 'setTenantId'
export const SETSELECTMENU = 'setSelectMenu'
export const UPDATETENANTID = 'updateTenantId'
export const PARENTNAVID = 'parentNavId'
export const UPDATEWEBSITE = 'updateWebsite'
export const UPDATEMOBILEEDITOR = 'updateMobileEditor'









// WEBPACK FOOTER //
// ./src/store/mutation-types.js